import React from 'react';
import Route from 'react-router/lib/Route';
import IndexRedirect from 'react-router/lib/IndexRedirect';
import { requireProductsEcommercePermission } from '../../../auth/routerHooks';
import ArchivedMatches from './components/ArchivedMatches';
import ConnectedMatches from './components/ConnectedMatches';
import Matches from './components/Matches';
import { BRAND_USER_BASE_URL, SHOP_USER_BASE_URL } from '../../../constants';

const MatchesRoutes = baseUrl => (
  <React.Fragment>
    <IndexRedirect to="matches" />
    <Route path="matches" component={() => <Matches baseUrl={baseUrl} />} />
    <Route path="dismissed" component={() => <ArchivedMatches baseUrl={baseUrl} />} />
    <Route path="linked" component={() => <ConnectedMatches baseUrl={baseUrl} />} />
  </React.Fragment>
);

export const ShopShopifyRoutes = store => (
  <Route path="shopify" onEnter={requireProductsEcommercePermission(store)}>
    {MatchesRoutes(SHOP_USER_BASE_URL)}
  </Route>
);

export const BrandShopifyRoutes = store => (
  <Route path="shopify" onEnter={requireProductsEcommercePermission(store)}>
    {MatchesRoutes(BRAND_USER_BASE_URL)}
  </Route>
);
